// import external dependencies
import 'jquery';
import 'fullpage.js/dist/jquery.fullpage.min.js';
// Import everything from autoload
import 'bootstrap';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import about from './routes/about';
import studio from './routes/studio';
import agency from './routes/agency';
import contact from './routes/contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  about,
  // Studio Page
  studio,
  // Studio Page
  agency,
  // Studio Page
  contact,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js